import { NotifyHelper } from "../../../helpers/toast";
import { objThucDonDefine } from "../../action-types/thuc-don/IFoThucDonActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const foThucDonActions = {
    ...generateActions(objThucDonDefine, "THUC_DON"),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "INSERT_MULTIPLE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "INSERT_MULTIPLE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objThucDonDefine, "THUC_DON",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
